export const toTitleCase = (str: string) => {
  return str
    .replace(/_/g, " ")
    .replace(/(\w*\W*|\w*)\s*/g, function (txt: string) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};
